var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJumpBackIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 74,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#jump_back_in_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32.752,
  height: 42.125,
  x: 15.49,
  y: 12.217,
  fill: "url(#jump_back_in_svg__b)",
  rx: 3.6
}), /*#__PURE__*/React.createElement("rect", {
  width: 35.152,
  height: 44.525,
  x: 14.29,
  y: 11.017,
  stroke: "#fff",
  strokeWidth: 2.4,
  rx: 4.801
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.499,
  d: "m35.123 28.654-9.062 9.062h-3.775V33.94l9.061-9.062z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.499,
  d: "m23.04 33.94 3.291 3.332h-3.29z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m35.995 24.042 6.869-5.478M38.826 28.946h4.413M31.842 21.304V16.89"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M21.495 42.997h22.197M21.495 48.246h22.197"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "jump_back_in_svg__b",
  x1: 15.49,
  x2: 48.242,
  y1: 33.28,
  y2: 33.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "jump_back_in_svg__a",
  width: 63.731,
  height: 73.105,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.272
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.545
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_826"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_826",
  result: "shape"
})))));
export default SvgJumpBackIn;